export default function Date({ value }) {
  return <span className="">{value?.split("T")[0]}</span>;
}
